module.exports = __webpack_public_path__ + "static/media/Buho_LogisticsBck1.16a72407.svg";